<template>
  <div class="pano-video-box">
      <a-form-model 
      :rules="ruleslive"
      ref="form"
      :model="form"
      :okText="$t('actionTitles.ascertain')"
      :cancelText="$t('actionTitles.cancel')"
      :label-col="{ span: 5 }"
      :wrapper-col="{ span: 15 }"
      >
        <a-form-model-item
        ref="cover"
        :label="$t('form.common.field.cover.label')"
        prop="cover"
      >
        <div class="pano-video-cover">
          <span class="tips">{{ $t("form.common.field.cover.tip") }}</span>
          <div
            class="pano-cover"
            :style="{ backgroundImage: 'url(' + form.cover + ')' }"
          >
            <div
              class="close-cover"
              v-if="form.cover"
              @click.stop="form.cover = ''"
            >
              <a-icon type="delete" />
            </div>
            <DragUploader
              ref="uploaderCover"
              uptype="cover"
              :callback="getUploaderCover"
            >
              <a-spin
                :spinning="uploadingCover"
                :tip="$t('message.uploading')"
                slot="body"
              >
                <div class="cover-data" v-show="!form.cover">
                  <span><a-icon type="plus" /></span>
                  <h4>{{ $t("form.common.field.cover.label") }}</h4>
                </div>
              </a-spin>
            </DragUploader>
          </div>
        </div>
      </a-form-model-item>

      <a-form-model-item ref="name" label="機位名稱" prop="name">
            <a-input
              v-model="form.name"
              placeholder="請輸入機位名稱"
            />
          </a-form-model-item>
          <a-form-model-item ref="url" label="直播地址" prop="url">
            <a-input
              v-model="form.url"
              placeholder="請輸入直播地址"
            />
          </a-form-model-item>
          <a-form-model-item ref="playback_url" label="回放地址">
            <a-input
              v-model="form.playback_url"
              placeholder="請輸入回放地址"
            />
          </a-form-model-item>
      </a-form-model>

  </div>
</template>

<script>
import DragUploader from "@/components/DragUploader";
import { materialAdd } from "@/api/planeMaterial";
export default {
    props: {
        dir_id: {
        type: Number,
        required: true,
        },
        form:{
          cover: "",
        },
  },
    components: { DragUploader },
    data(){
        return{
            ruleslive:{
                cover: [
                {
                    required: true,
                    message: this.$t("form.common").field.cover.message,
                    trigger: "blur",
                },
                ],
                name: [
                {
                    required: true,
                    message: "請輸入直播名稱",
                    trigger: "blur",
                },
                ],
                url: [
                {
                    required: true,
                    message: "請輸入直播地址",
                    trigger: "blur",
                },
                ],
            },
            uploadingCover: false,
        }
    },
    methods:{
        getUploaderCover(up) {
            this.$nextTick(() => {
                up.bind("FilesAdded", (up, file) => {
                this.uploadingCover = true;
                });
                up.bind("Error", (up, file) => {
                this.uploadingCover = false;
                });
                up.bind("UploadComplete", (up, file) => {
                this.uploadingCover = false;
                this.form.cover = this.$refs.uploaderCover.fileList[0].url;
                this.$refs.form.clearValidate("cover");
                });
            });
        },
        savePanoramic() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                let data = [{ ...this.form, filesize:0 ,type: 5, dir_id: this.dir_id }];
                materialAdd(data).then((res) => {
                    if (res.code == 1) {
                    this.$message.success(this.$t("message.saveSuccess"));
                    this.$emit("refresh");
                    this.$emit("cancel");
                    }
                });
                }
            });
        },
    }

}
</script>

<style lang="less" scoped>
.pano-video-box {
  padding: 0 10px;
  .pano-video-cover {
    position: relative;
    border-bottom: 1px solid #efefef;
    .pano-cover {
      width: 200px;
      height: 200px;
      border-radius: 5px;
      background-color: #f1f1f1;
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
      .close-cover {
        position: absolute;
        z-index: 1000;
        width: 30px;
        height: 30px;
        border-radius: 4px;
        background-color: rgba(0, 0, 0, 0.6);
        display: flex;
        align-items: center;
        justify-content: center;
        color: #ffffff;
        font-size: 16px;
        top: 5px;
        right: 5px;
        transition: background-color 0.3s ease;
        cursor: pointer;
        &:hover {
          background-color: rgba(0, 0, 0, 0.8);
        }
      }
      .cover-data {
        width: 100%;
        height: 100%;
        text-align: center;
        font-size: 0;
        padding: 70px 20px 0 20px;
        line-height: normal;
        span {
          width: 36px;
          height: 36px;
          line-height: 34px;
          border-radius: 50%;
          background-color: #1890ff;
          color: #ffffff;
          font-size: 22px;
          display: inline-block;
        }
        h4 {
          font-size: 14px;
          margin-top: 10px;
          line-height: 160%;
          color: #999;
        }
      }
    }
  }
  .tips {
    font-size: 12px;
    color: #999;
    line-height: normal;
  }
}
@media (max-width: 767px) {
  .pano-video-box {
    padding: 0;
    /deep/ .ant-form-item-label {
      padding-bottom: 0;
    }
    .pano-video-cover {
      padding: 0 0 30px 0;
      line-height: normal;
      .pano-cover {
        width: 200px;
        height: 200px;
      }
    }
    .tips {
      position: inherit;
      top: auto;
      right: auto;
      font-size: 12px;
      display: inline-block;
      margin: 3px 0 10px 0;
    }
  }
}
</style>